import { NgModule } from '@angular/core';

import { CmpsInsightCoachingProgressBarComponent } from './insight-coaching-progress-bar.component';

@NgModule({
    declarations: [CmpsInsightCoachingProgressBarComponent],
    exports: [CmpsInsightCoachingProgressBarComponent],
})
export class CmpsInsightCoachingProgressBarModule {}
